import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { fonts, colors } from './mixins.js';
import ImageLink from './ImageLink.jsx';
import useModal from "../../hooks/useModal";
import Icon from './Icon.jsx';
import Overlay from "../common/Overlay";
import Button from "../common/Button"
import GovWalletInfo from '../order-details/GovWalletInfo.jsx'

//external wrapper- with fixed width
//height:100%;
const CardWrapper = styled.div`
width: 297px;
user-select: none;
height:100%;
display: flex;
flex-direction: column;
`;

// label conainer-above
const LabelContainer = styled.div`
display:flex;
justify-content:flex-end;
`;
//label
const Label = styled.div`
    ${fonts.normalTextExtraSmall()};
    width:fit-content;
    height:18px;
    display:flex;
    align-items:center;
    justify-content:center;
    padding: ${(props) => props.isPending ? "2px 8px 2px 4px" : "2px 8px"};
    background-color:${(props) => getLabelColor(props.status, props.isPending) };
    color:white;
    border-radius: 4px 4px 0 0;
    `;


// generic container
const CardContainer = styled.div`
   background-color:white;
   height: 100%;
   padding:8px;
   border-radius:${(props) => props.status === 'CO' ? '8px' :'8px 0 8px 8px'};
   border: ${(props) => getContainerBorder(props.status, props.isPending)};
   flex-shrink: 0;
   flex: 1;
   display:flex;
   flex-direction:column;
   gap:8px;
   opacity: ${(props) => (props.isPending ? 0.4 : 1)};
    `;

//top section
const noImage = '/Site/images/icons/order-details/noImage.svg';
const ImageContainer = styled.div`   
  min-height:163px;
  border-radius:8px;
 background: 
    url(${(props) => props.url||noImage}) no-repeat center center / cover;

  position: relative;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  padding:8px 8px 16px 12px;

   &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 83px;
    border-radius: 0 0 8px 8px; 
    background: linear-gradient(360deg, #0D0C1C 0%, rgba(13, 12, 28, 0.475) 42.61%, rgba(13, 12, 28, 0.1) 73.59%, rgba(13, 12, 28, 0) 86.08%)
  }
    `;

const Title = styled.div`
 ${fonts.normalTextSmall()};
 line-height:18px;
 font-weight:600;
 color:white;
 z-index:300;
`;

const Count = styled.div`
line-height:20px;
border-radius:24px;
opacity:0.8;
background-color:${colors.darkText};
 ${fonts.normalTextSmall()}; 
 font-weight:600;
 color:white;
 display:flex;
 align-items:center;
 justify-content:center;
 padding: 0 10px;
 max-width: fit-content;
`;

//middle section
const DetailsContainer = styled.div`
    padding: ${({ walletsLinks }) => (walletsLinks ? '8px 8px 16px 8px' : '8px')};
    border-radius:8px;
    border: 1px solid #EDF1F6;
   display:flex;
   flex-direction:column;
  height:100%;
    `;

const DetailsTop = styled.div`
    padding-bottom:16px;
    margin-bottom:16px;
    border-bottom: 1px solid #EDF1F6;
    `;
const DetailsBottom = styled.div`
flex-grow: 1
    `;

//bottom section- won't be shown if status!=='CO'
const ActionsContainer = styled.div`
border: 1px solid #EDF1F6;
   padding:16px 8px 8px 8px;
    border-radius:8px;
    `;

const BarcodeContainer = styled.div`
   border-bottom: ${(props) => props.hasLinks ? '1px solid #EDF1F6' : 'none'};
   margin-bottom:${(props) => props.hasLinks ? '16px' : '0'};
   padding-bottom:${(props) => props.hasLinks ? '16px' : '8px'};
    `;

const ButtonsContainer = styled.div`
display:flex;
justify-content:space-between;
gap: 8px;
min-height: 40px;
    `;

const ModalContainer = styled.div`
    text-align: center;
`;

const ModalTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #000;
  margin-bottom: 24px;
  font-family: 'pf_highway_sans_pro_lightRg';
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  & > a {
    flex-grow: 1;
  }
`;

const getContainerBorder = (status, isPending) => {
    if (isPending) {
        return `1px solid #A8ABAF`
    }

    switch (status) {
        case 'PE':
            return `1px solid  ${colors.warning}`;
        case 'CN':
            return `1px solid  ${colors.danger}`;
        default:
            return `1px solid  transparent`;
    }
};

const getLabelColor = (status, isPending) => {
    if (isPending) {
        return `#A8ABAF`
    }
    switch (status) {
        case 'PE':
            return `${colors.warning}`;
        case 'CN':
            return `${colors.danger}`;
        default:
            return `transparent`;
    }
};

const getLabelText = (status, isPending, walletsLinks) => {
    if (isPending) {
        if (walletsLinks) {
            return `${orderdetails_resources.LoadingTicket}`;
        } else {
            return `${orderdetails_resources.LoadingProduct}`;
        }
    }

    if (status === 'PE') {
        return `${orderdetails_resources.PendingPayment}`;
    }
    if (status === 'CN') {
        return `${orderdetails_resources.Cancelled}`;
    }

};
export default function Card({ cardProps, count, walletsLinks = {}, hasLabel, orderStatus}) {
    const { detailsTop, detailsBottom, barcode, status, title, imageUrl, gov = {} }=cardProps;
    const [isPending, setIsPending] = useState(false);
    const [modalContext, setModalContext] = useState("")
    const { isOpen, openModal, closeModal } = useModal();

    const { ticketId, govStatus, isGovWalletEnabled } = gov;

    useEffect(() => {
    const isStillPending = orderStatus?.orderStatus === 'IN' ||
        (orderStatus?.orderStatus === 'CO' && 
        (!orderStatus?.areTicketsEnabled || !orderStatus?.areProductsEnabled));

        setIsPending(isStillPending);
    }, [orderStatus]);

    const handleOpenModal = (context) => {
        setModalContext(context);
        openModal();
    }

    const modalConfig = {
        google: {
            single: walletsLinks?.google,
            bundle: walletsLinks?.googleBundle,
        },
        apple: {
            single: walletsLinks?.apple,
            bundle: walletsLinks?.appleBundle,
        },
    };

    const WalletModalContent = ({ singleUrl, bundleUrl }) => (
        <ModalContainer>
            <ModalTitle>{orderdetails_resources.AddAllTicketsTitle}</ModalTitle>
            <ButtonsWrapper>
                <Button
                    type="secondary"
                    target="_self"
                    url={singleUrl}
                    height="48px"
                    text={orderdetails_resources.AddOneTicket}
                />
                <Button
                    type="primary"
                    target="_self"
                    url={bundleUrl}
                    height="48px"
                    text={orderdetails_resources.AddAllTickets}
                />
            </ButtonsWrapper>
        </ModalContainer>
    );
  
    return (
        <>
        <CardWrapper>
            <LabelContainer>
                {hasLabel&&
                    <Label status={status} isPending={!!isPending}>{isPending && <div style={{marginRight: 4}}><Icon kind="loading_spinner" /></div>}{getLabelText(status, isPending, walletsLinks)}</Label>}
            </LabelContainer>
            <CardContainer status={status} isPending={!!isPending}>
            <ImageContainer url={imageUrl}>
                    <Count>{count.item}/{count.total}</Count>
            <Title>{title}</Title>
            </ImageContainer>
                <DetailsContainer walletsLinks={walletsLinks}>
                    {detailsTop && <DetailsTop>
                        {detailsTop}
                    </DetailsTop>}
                <DetailsBottom>
                        {detailsBottom}
                </DetailsBottom>             
            </DetailsContainer> 
                {status === 'CO' && isGovWalletEnabled && <GovWalletInfo isPending={govStatus === 'PE'} ticketId={ticketId} />}
                {status === 'CO' && !isPending && !isGovWalletEnabled && <ActionsContainer>
                    <BarcodeContainer hasLinks={walletsLinks}>
                        {barcode}
                </BarcodeContainer>
                    {walletsLinks&&<ButtonsContainer>
                        <ImageLink  type="appleWallet" onClick={() => handleOpenModal("apple")} href={walletsLinks.apple} totalTickets={count.total}/>
                        <ImageLink  type="googleWallet" onClick={() => handleOpenModal("google")} href={walletsLinks.google} totalTickets={count.total}/>
                </ButtonsContainer>}
            </ActionsContainer>}
            </CardContainer>
        </CardWrapper>
        <Overlay
            handleClose={() => {
                closeModal();
                setModalContext("");
            }}
            open={isOpen}
            size="sm"
            id="add-multiple-tickets-modal"
            titleText={orderdetails_resources.AddTicketsToWallet}
        >
           {modalContext && modalConfig[modalContext] && (
                <WalletModalContent
                    singleUrl={modalConfig[modalContext].single}
                    bundleUrl={modalConfig[modalContext].bundle}
                />
            )}
        </Overlay>
        </>
    );
}